// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"00c984ee","885":"ca486e9a"}[chunkId] + ".chunk.js";
};